/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

// action - account reducer
export const LOGIN = "@auth/LOGIN";
export const LOGOUT = "@auth/LOGOUT";
export const REGISTER = "@auth/REGISTER";
